import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { PageHead, Pager, Person, Table, Tabs, Tiles, fmt } from "./kit";

const cell = { width: "100%", padding: "6px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

/// Fan kulubu: aylik ucret, yayinci payi ve seviye esikleri.
const FanClub = () => {
  const [tab, setTab] = useState("ayar");
  const [cfg, setCfg] = useState(null);
  const [rows, setRows] = useState({ data: [], total: 0 });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        fanClubEnabled: r.config.fanClubEnabled !== false,
        fanClubMonthlyCoin: Number(r.config.fanClubMonthlyCoin) || 0,
        fanClubHostShare: Number(r.config.fanClubHostShare) || 0,
        fanLevels: r.config.fanLevels || [],
      });
    }
  }, []);

  const loadRows = useCallback(async () => {
    setLoading(true);
    const r = await api.fanClubs({ start: page, limit: 25 });
    if (r?.status) setRows(r);
    setLoading(false);
  }, [page]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    if (tab === "liste") loadRows();
  }, [tab, loadRows]);

  const save = async (next = cfg) => {
    setSaving(true);
    const r = await api.saveConfig(next);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  const setLevel = (i, k, v) => {
    const levels = cfg.fanLevels.map((t, j) => (i === j ? { ...t, [k]: v } : t));
    setCfg({ ...cfg, fanLevels: levels });
  };

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  return (
    <>
      <PageHead
        title="Fan Kulübü"
        sub="Kullanıcı aylık ücretle bir yayıncının fanı olur. Rozet sohbette görünür, seviye yayıncıya gönderilen coinle yükselir."
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.fanClubEnabled ? "Açık" : "Kapalı" },
          { label: "Aylık ücret", value: fmt(cfg.fanClubMonthlyCoin) },
          { label: "Yayıncı payı", value: `%${cfg.fanClubHostShare}` },
        ]}
      />

      <Tabs
        tabs={[
          ["ayar", "Ayarlar"],
          ["liste", "Kulüpler"],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === "ayar" && (
        <div className="card">
          <div className="card-body" style={{ maxWidth: 620 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
              <input
                type="checkbox"
                checked={cfg.fanClubEnabled}
                onChange={(e) => setCfg({ ...cfg, fanClubEnabled: e.target.checked })}
              />
              <b>Fan kulübü açık</b>
            </label>

            <div className="d-flex" style={{ gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
              <div>
                <div style={small}>Aylık ücret (coin)</div>
                <input
                  style={{ ...cell, width: 160 }}
                  type="number"
                  value={cfg.fanClubMonthlyCoin}
                  onChange={(e) => setCfg({ ...cfg, fanClubMonthlyCoin: Number(e.target.value) })}
                />
              </div>
              <div>
                <div style={small}>Yayıncı payı (%)</div>
                <input
                  style={{ ...cell, width: 120 }}
                  type="number"
                  value={cfg.fanClubHostShare}
                  onChange={(e) => setCfg({ ...cfg, fanClubHostShare: Number(e.target.value) })}
                />
              </div>
            </div>

            <b style={{ fontSize: 14 }}>Seviyeler</b>
            <div style={{ ...small, marginBottom: 8 }}>t = yayıncıya gönderilen toplam coin (yakınlık)</div>
            {cfg.fanLevels.map((l, i) => (
              <div className="d-flex" style={{ gap: 8, marginBottom: 8 }} key={i}>
                <span style={{ ...small, width: 22, paddingTop: 7 }}>{i + 1}</span>
                <input
                  style={{ ...cell, width: 180 }}
                  value={l.name || ""}
                  placeholder="Seviye adı"
                  onChange={(e) => setLevel(i, "name", e.target.value)}
                />
                <input
                  style={{ ...cell, width: 160 }}
                  type="number"
                  value={l.t || 0}
                  onChange={(e) => setLevel(i, "t", Number(e.target.value))}
                />
              </div>
            ))}

            <button className="btn btn-primary" disabled={saving} onClick={() => save()} style={{ marginTop: 10 }}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </div>
      )}

      {tab === "liste" && (
        <>
          <Table
            head={["Yayıncı", "Kulüp adı", "Üye", "Toplam yakınlık"]}
            loading={loading}
            empty="Henüz kulüp yok."
            rows={rows.data.map((r) => (
              <tr key={r.hostId}>
                <td>
                  <Person image={r.hostImage} name={r.hostName} />
                  <div style={small}>ID {r.uniqueID}</div>
                </td>
                <td>{r.name || "—"}</td>
                <td>{fmt(r.memberCount)}</td>
                <td>{fmt(r.totalIntimacy)}</td>
              </tr>
            ))}
          />
          <Pager page={page} size={25} total={rows.total} onChange={setPage} />
        </>
      )}
    </>
  );
};

export default FanClub;
